module.exports = __webpack_public_path__ + "media/images/ach_savings-6da24d01a8965c58bb941c88af9243a7.svg";